import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';

import PinnedBuildingsContainer from '../Building/PinnedBuildingsContainer';

import { getIsAccessCardsShown } from '../../utils';
import {
  getIsCommunityShown,
  getIsEventsShown,
  getIsManagementCompanyShown,
} from './utils';

import { ACCESS_LEVELS } from './constants';

import {
  activityIcon,
  amenityIcon,
  buildingIcon,
  cardIcon,
  deliveryIcon,
  docIcon,
  eventsIcon,
  externalAccountIcon,
  ipIcon,
  monetizationIcon, // exportIcon,
  pmcIcon,
  remoteDoormanIcon,
  searchIcon,
  srIcon,
  visitorIcon,
} from '../../res/svg/icons';

export const getMenuData = () => [
  {
    access: ACCESS_LEVELS.ALL,
    type: 'sub-header',
    url: '',
    label: 'MANAGEMENT',
    subMenu: [
      {
        access: ACCESS_LEVELS.ALL,
        show: getIsManagementCompanyShown(),
        type: 'item',
        url: `/pmcs`,
        label: 'Management Company',
        icon: pmcIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ADMIN,
        type: 'item',
        url: '/pmcs',
        label: 'Property Management Companies',
        icon: pmcIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/buildings',
        label: 'Buildings',
        icon: buildingIcon,
        subMenu: [],
        subComponents: [PinnedBuildingsContainer],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/global-person-search',
        label: 'Global Person Search',
        icon: searchIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ADMIN,
        type: 'item',
        url: '/ip-management',
        label: 'IP Management',
        icon: ipIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ADMIN,
        type: 'item',
        url: '/carson-activity',
        label: 'Carson Activity',
        icon: activityIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ADMIN,
        type: 'item',
        url: '/external-accounts-settings',
        label: 'External Accounts',
        icon: externalAccountIcon,
        subMenu: [],
      },
    ],
  },
  {
    access: ACCESS_LEVELS.ALL,
    type: 'sub-header',
    url: '',
    label: 'OPERATIONS',
    subMenu: [
      {
        access: ACCESS_LEVELS.ALL,
        show: getIsCommunityShown(),
        type: 'item',
        url: '/community',
        label: 'Community',
        icon: <PeopleOutlineIcon sx={{ color: '#A246AD' }} />,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/deliveries',
        label: 'Deliveries',
        icon: deliveryIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/service-requests',
        label: 'Service Requests',
        icon: srIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/visitors',
        label: 'Visitor Management',
        icon: visitorIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ADMIN,
        type: 'item',
        url: '/remote-doorman',
        label: 'Remote Doorman',
        icon: remoteDoormanIcon,
        customViewBox: '0 0 23 29',
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        show: getIsAccessCardsShown(),
        type: 'item',
        url: '/access-cards',
        label: 'Access Cards',
        icon: cardIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/document-library',
        label: 'Document Library',
        icon: docIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/amenity',
        label: 'Amenity Reservations',
        icon: amenityIcon,
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ALL,
        show: getIsEventsShown(),
        type: 'item',
        url: '/events',
        label: 'Events',
        icon: eventsIcon,
        customViewBox: '0 0 24 24',
        subMenu: [],
      },
      {
        access: ACCESS_LEVELS.ADMIN,
        type: 'item',
        url: '/billing-report',
        label: 'Monthly Bill',
        icon: monetizationIcon,
        customViewBox: '0 0 24 24',
        subMenu: [],
      },
      /* {
        access: ACCESS_LEVELS.ALL,
        type: 'item',
        url: '/exports',
        label: 'Exports',
        icon: exportIcon,
        subMenu: [],
      }, */
    ],
  },
];
